import { IManageOutfit, IManageOutfitAction } from 'models/outfit/manageoutfit';
import { change } from 'redux-form';
import { IOutfit } from 'models/outfit/outfit';
import { IStore } from 'redux/IStore';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
import * as c from 'models/constants';
import { arrayMove } from 'react-sortable-hoc';
import { IOutfitItem } from 'models/outfit/outfititem';
import { closeModal, showModal } from '../../modal';
import { SearchUsage } from 'models';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST: string = 'manageoutfit/REQUEST';
export const MANAGE_OUTFIT_SUCCESS: string = 'manageoutfit/MANAGE_OUTFIT_SUCCESS';
export const MANAGE_OUTFIT_FAILURE: string = 'manageoutfit/MANAGE_OUTFIT_FAILURE';
export const SET_SELECTED_OUTFIT: string = 'manageoutfit/SET_SELECTED_OUTFIT';
export const SET_OUTFIT_UPDATED: string = 'manageoutfit/SET_OUTFIT_UPDATED';
export const SET_OUTFIT_CREATED: string = 'manageoutfit/SET_OUTFIT_CREATED';
export const CLEAR_FORM_DATA: string = 'manageoutfit/CLEAR_FORM_DATA';
export const VALIDATION_ERROR: string = 'manageoutfit/VALIDATION_ERROR';
export const CLEAR_FORM_ERROR: string = 'manageoutfit/CLEAR_FORM_ERROR';
export const NEXT_STEP: string = 'manageoutfit/NEXT_STEP';
export const PREVIOUS_STEP: string = 'manageoutfit/PREVIOUS_STEP';
export const CHANGE_SELECTED_TAB: string = 'manageoutfit/CHANGE_SELECTED_TAB';
export const SET_OUTFIT_ITEMS: string = 'manageoutfit/SET_OUTFIT_ITEMS';
export const SET_IS_EDIT_MODE: string = 'manageoutfit/SET_IS_EDIT_MODE';

/** Initial State */
const initialState: IManageOutfit = {
	isFetching: false,
	outfit: {
		items: '[]',
		itemsJArray: [],
		images: [],
		selectedImages: [],
		selectedThumbnail: null,
		published: false,
	},
	isEditMode: false,
	wizardStep: 1,
};

/** Reducer */
export function manageOutfitReducer(state = initialState, action: IManageOutfitAction) {
	switch (action.type) {
		case REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case MANAGE_OUTFIT_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				outfit: action.payload.outfit,
			});

		case MANAGE_OUTFIT_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case CLEAR_FORM_DATA:
			return Object.assign({}, state, {
				isFetching: false,
				outfit: {
					items: '[]',
					itemsJArray: [],
					images: [],
					selectedImages: [],
					selectedThumbnail: null,
					published: false,
				},
				isEditMode: false,
				wizardStep: 1,
			});

		case NEXT_STEP:
			return Object.assign({}, state, {
				wizardStep: state.wizardStep + 1,
			});

		case PREVIOUS_STEP:
			return Object.assign({}, state, {
				wizardStep: state.wizardStep - 1,
			});

		case SET_OUTFIT_ITEMS:
			return Object.assign({}, state, {
				outfit: {
					...state.outfit,
					items: action.payload.itemsString,
				},
				isFetching: false,
			});

		case SET_IS_EDIT_MODE:
			return Object.assign({}, state, {
				isEditMode: action.payload.isEditMode,
			});

		case VALIDATION_ERROR:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case CLEAR_FORM_ERROR:
			return Object.assign({}, state, {
				isFetching: false,
				message: null,
				error: false,
			});

		default:
			return state;
	}
}

/** Action Creator - create */
export function submitCreateOutfit(outfit: IOutfit, onCreateOutfitSuccess: (res: IOutfit) => void) {
	return (dispatch, getState: () => IStore) => {
		dispatch(request());

		outfit.metatagTitle = outfit.name;
		outfit.metatagKeywords = outfit.name;
		outfit.metatagDescription = outfit.description;
		outfit.userId = getState().userPreferences.id;

		const images = outfit.images ? outfit.images.filter((x) => x.id && x.href) : [];
		const thumbnailImageIndex = images.findIndex((x) => x.id === outfit.selectedThumbnail);
		if (thumbnailImageIndex > -1) {
			outfit.images = arrayMove(images, thumbnailImageIndex, 0);
		}

		if (images.length === 0) {
			outfit.picture = outfit.itemsJArray[0].picture;
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Outfit',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(outfit),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IOutfit) => {
						dispatch(
							notifSend({
								message: i18n.t('Notification_Success_Outfit_Created'),
								kind: 'success',
								dismissAfter: 3000,
							}),
						);
						dispatch(closeModal());
						if (onCreateOutfitSuccess) {
							onCreateOutfitSuccess(res);
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(outfitRequestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(outfitRequestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(outfitRequestFailure(err));
			});
	};
}

export function submitUpdateOutfit(outfit: IOutfit, onUpdateOutfitSuccess: (outfit: IOutfit) => void) {
	return (dispatch, getState: () => IStore) => {
		dispatch(request());

		outfit.metatagTitle = outfit.name;
		outfit.metatagKeywords = outfit.name;
		outfit.metatagDescription = outfit.description;
		outfit.userId = getState().userPreferences.id;

		const images = outfit.images ? outfit.images.filter((x) => x.id && x.href) : [];
		const thumbnailImageIndex = images.findIndex((x) => x.id === outfit.selectedThumbnail);
		if (thumbnailImageIndex > -1) {
			outfit.images = arrayMove(images, thumbnailImageIndex, 0);
		}

		if (images.length === 0) {
			outfit.picture = outfit.itemsJArray[0].picture;
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Outfit/' + outfit.id,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(outfit),
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(
						notifSend({ message: i18n.t('Notification_Success_Outfit_Updated'), kind: 'success', dismissAfter: 3000 }),
					);
					dispatch(closeModal());
					if (onUpdateOutfitSuccess) {
						onUpdateOutfitSuccess(outfit);
					}
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(outfitRequestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(outfitRequestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(outfitRequestFailure(err));
			});
	};
}

/** Async Action Creator */
export function editOutfit(
	id: string,
	userId: string,
	wardrobeItemsSearchUsage: SearchUsage,
	onUpdateOutfitSuccess: (outfit: IOutfit) => void,
) {
	return (dispatch, getState: () => IStore) => {
		dispatch(request());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Outfit/' + id + '/edit',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IOutfit) => {
						dispatch(manageOutfitSuccess(res));
						dispatch(setIsEditMode(true));
						dispatch(
							showModal('ManageOutfit', {
								closeModal: dispatch(closeModal),
								userId,
								wardrobeItemsSearchUsage,
								onUpdateOutfitSuccess,
							}),
						);
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(outfitRequestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(outfitRequestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(outfitRequestFailure(err));
			});
	};
}

//TODO: translation
export function addOutfitItem(item: IOutfitItem) {
	return (dispatch, getState: () => IStore) => {
		const outfit: IOutfit = getState().manageOutfit.outfit;
		item.order = outfit.itemsJArray.length;
		outfit.itemsJArray.push(item);

		updateOutfitItemsData(dispatch, outfit);

		dispatch(notifSend({ message: 'Item added', kind: 'success', dismissAfter: 3000 }));
	};
}

//TODO: translation
export function removeOutfitItem(index: number) {
	return (dispatch, getState: () => IStore) => {
		const outfit: IOutfit = getState().manageOutfit.outfit;
		outfit.itemsJArray.splice(index, 1);
		outfit.itemsJArray = reindexOutfitItems(outfit.itemsJArray);

		updateOutfitItemsData(dispatch, outfit);

		dispatch(notifSend({ message: 'Item removed', kind: 'success', dismissAfter: 3000 }));
	};
}

function updateOutfitItemsData(dispatch, outfit: IOutfit) {
	dispatch(setOutfitItems(JSON.stringify(outfit.itemsJArray)));
	dispatch(change(c.FORM_NAME_MANAGEOUTFIT, 'items', JSON.stringify(outfit.itemsJArray)));
	dispatch(change(c.FORM_NAME_MANAGEOUTFIT, 'itemsJArray', outfit.itemsJArray));
}

function reindexOutfitItems(items: IOutfitItem[]) {
	let i;
	for (i = 0; i < items.length; i++) {
		items[i].order = i;
	}
	return items;
}

/** Action Creator */
export function request(): IManageOutfitAction {
	return {
		type: REQUEST,
	};
}

/** Action Creator */
export function manageOutfitSuccess(outfit: IOutfit): IManageOutfitAction {
	return {
		type: MANAGE_OUTFIT_SUCCESS,
		payload: {
			outfit,
		},
	};
}

/** Action Creator */
export function outfitRequestFailure(message: any): IManageOutfitAction {
	return {
		type: MANAGE_OUTFIT_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function clearOutfitFormData(): IManageOutfitAction {
	return {
		type: CLEAR_FORM_DATA,
	};
}

/** Action Creator */
export function nextStep(): IManageOutfitAction {
	return {
		type: NEXT_STEP,
	};
}

/** Action Creator */
export function previousStep(): IManageOutfitAction {
	return {
		type: PREVIOUS_STEP,
	};
}

/** Action Creator */
export function setOutfitItems(itemsString: string): IManageOutfitAction {
	return {
		type: SET_OUTFIT_ITEMS,
		payload: {
			itemsString,
		},
	};
}

/** Action Creator */
export function setOutfitValidationFailure(error: any): IManageOutfitAction {
	return {
		type: VALIDATION_ERROR,
		payload: {
			message: error,
		},
	};
}

/** Action Creator */
export function clearOutfitFormError(): IManageOutfitAction {
	return {
		type: CLEAR_FORM_ERROR,
	};
}

/** Action Creator */
export function setIsEditMode(isEditMode: boolean): IManageOutfitAction {
	return {
		type: SET_IS_EDIT_MODE,
		payload: {
			isEditMode,
		},
	};
}
